import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, Building, Users } from "lucide-react";
import { useAuthStore } from "@/pages/auth/auth.store";
import logoFull from "@/assets/images/logo_full.png";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="w-[250px] h-full flex flex-col bg-[#0F1524] border-r border-[#1A2235]">
      {/* Logo and Organization */}
      <div className="py-2 border-b border-[#1A2235]">
        <Link to="/profile" className="flex items-center justify-center w-full">
          <img
            src={logoFull}
            alt="DocuTalk Logo"
            className="w-full object-contain max-h-16"
            style={{
              imageRendering: "crisp-edges",
              WebkitBackfaceVisibility: "hidden",
              backfaceVisibility: "hidden",
              filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.2))",
            }}
          />
        </Link>
      </div>

      {/* Navigation Links */}
      <div className="flex-1 overflow-y-auto px-3 py-4">
        <nav className="space-y-1">
          <Link
            to="/organizations"
            className={`flex items-center gap-3 p-2 rounded-lg hover:bg-[#1A2235] w-full text-sm ${
              location.pathname === "/organizations"
                ? "bg-[#1A2235] text-white"
                : "text-gray-300"
            }`}
          >
            <Building size={16} />
            <span>Organizations</span>
          </Link>
          <Link
            to="/users"
            className={`flex items-center gap-3 p-2 rounded-lg hover:bg-[#1A2235] w-full text-sm ${
              location.pathname === "/users"
                ? "bg-[#1A2235] text-white"
                : "text-gray-300"
            }`}
          >
            <Users size={16} />
            <span>Users</span>
          </Link>
        </nav>
      </div>

      {/* Logout Button */}
      <div className="px-3 py-2 border-t border-[#1A2235]">
        <button
          onClick={handleLogout}
          className="flex items-center justify-center gap-2 text-[#EF4444] p-2 rounded-lg hover:bg-[#1A2235] w-full text-xs"
        >
          <LogOut size={14} />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}
